/** @format */

import { Button, Col, Row, Grid } from "antd";
import Link from "next/link";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import Footer from "../components/Footer";
import { getStaticProps } from "../../methods/i18n";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import SEO from "../components/seo";
import { HeadScriptTag } from "../components/HeadScriptTag";

export { getStaticProps };

export default function NewClientsIntro() {
	const { useBreakpoint } = Grid;
	const screenSize = useBreakpoint();
	const { t } = useTranslation(["breadcrumb_section", "meta_tags"]);

	const title = t("meta_tags:new_clients_intake_overview");
	const description =	t("meta_tags:new_clients_intake_overview_desc");
	const keywords = "Tax,Tax Bankruptcy ,Tax Controversy";
	// const ogImage = "https://www.example.com/static/images/og-image.jpg";
	const ogType = "website";
	const canonicalURL = "https://www.taxworkoutgroup.net/new-clients-intake-overview";

	return (
		<>
			<SEO
				title={title}
				description={description}
				keywords={keywords}
				// ogImage={ogImage}
				ogType={ogType}
				canonicalURL={canonicalURL}
			/>
      <HeadScriptTag />
			<CustomBreadcrumb
				items={[
					{
						label: t("breadcrumb_section:home"),
						href: "/",
					},
					{
						label: t("breadcrumb_section:new_clients"),
						href: "/new-clients/0",
					},
					{
						label: t("breadcrumb_section:new_clients_intake_overview"),
						href: "/new-clients-intake-overview",
					},
				]}
			/>
			<Row
				justify={"center"}
				style={{ paddingTop: 50, paddingBottom: 50 }}
				gutter={[30, 30]}>
				<Col span={24} style={{ textAlign: "center" }}>
					<div className='section_title'>
						<h1>Our New Client Intake Process</h1>
					</div>
				</Col>
				<Col span={24} style={{ textAlign: "center" }}>
					<Image
						// placeholder={<Image src='/blank_placeholder.png' alt='' />}
						// style={{ width: '100%' }}
						src='/newClient.png'
						// //preview={false}
						alt='intro image'
						className='stext5'
						width={
							screenSize.sm
								? screenSize.lg
									? screenSize.xl
										? 1400
										: 1000
									: 768
								: 325
						}
						height={
							screenSize.sm
								? screenSize.lg
									? screenSize.xl
										? 440
										: 340
									: 300
								: 150
						}
					/>
				</Col>
				<Col>
					<Link href='/new-clients/0'>
						<Button size='large' type='primary'>
							Start Your Free Tax Case Consultation
						</Button>
					</Link>
				</Col>
			</Row>
			<Footer />
		</>
	);
}
